import React from "react";
import { Box } from '@mui/material';
import {
  Route,
  Routes,
} from "react-router-dom";
import FboSummaries from '../../features/dashboard/fbos/FboSummaries';
import CloudportSummaries from '../../features/dashboard/cloudports/CloudportSummaries';
import UncommissionedSummaries from '../../features/dashboard/uncommissioned/UncommissionedSummaries';
import NavBar, {Pages} from './NavBar';
import ErrorModal from "../../features/error/ErrorModal";
import SoftwareManagement from "../../features/software/SoftwareManagement";

export const PageLayout = (props) => {

    return (
        <Box
            component="main"
            sx={{ display: 'flex', flexGrow: 1, height: '100vh', overflow: 'auto' }}
        >
            <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                p: 0,
            }}
            >
                <NavBar />
                <Routes>
                    <Route
                    path="/"
                    element={ <FboSummaries /> }
                    />
                    <Route 
                    path="summaries" 
                    element={ <FboSummaries /> } />
                    <Route
                    path={Pages.FBO.path}
                    element={ <FboSummaries /> }
                    /> 
                    <Route
                    path={Pages.CloudPort.path}
                    element={ <CloudportSummaries /> }
                    />
                    <Route
                    path={Pages.Uncommissioned.path}
                    element={ <UncommissionedSummaries /> }
                    />
                    <Route
                    path={Pages.Software.path}
                    element={ <SoftwareManagement /> }
                    />
                </Routes>
            </Box>
            <ErrorModal />
        </Box>
    );
};
export default PageLayout;